// The credits panel (Credits button at the bottom of the menu): everyone whose work the game uses,
// with what we used, the licence and links. Licence texts ship in public/licenses/.

interface Credit {
  what: string;
  title: string;
  author: string;
  authorUrl?: string;
  source: string;
  license: string;
  licenseUrl?: string;
  changes?: string;
}

const CC_BY_4 = 'https://creativecommons.org/licenses/by/4.0/';

const ASSETS: Credit[] = [
  {
    what: 'Arms and hands',
    title: 'FP arms',
    author: 'DJMaesen',
    authorUrl: 'https://sketchfab.com/bumstrum',
    source: 'https://sketchfab.com/3d-models/fp-arms-06ee1407117d4e5ab343becb4ee44bb6',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Textures resized; posed in code to hold the knife and pistol.',
  },
  {
    what: 'Knife',
    title: 'Karambit',
    author: 'Astral',
    authorUrl: 'https://sketchfab.com/Astral_27',
    source: 'https://sketchfab.com/3d-models/karambit-2a13d3d4ed754950886f3bdeeebcf8ea',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Simplified and recoloured with the game’s finishes.',
  },
  {
    what: 'Butterfly knife',
    title: 'CSGO-Styled Butterfly Knife',
    author: 'Aslady',
    authorUrl: 'https://sketchfab.com/Aslady',
    source: 'https://sketchfab.com/3d-models/csgo-styled-butterfly-knife-6f023e5fb12947e18ce2d93d38e13cfd',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into blade and handles and simplified; recoloured with the game’s finishes.',
  },
  {
    what: 'M9 bayonet',
    title: 'M9 Bayonet (Fade)',
    author: 'Firewarden',
    authorUrl: 'https://sketchfab.com/Firewarden',
    source: 'https://sketchfab.com/3d-models/m9-bayonet-fade-5860edcf68ae4cf18929110aa3093d8c',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into blade, guard and grip; its textures replaced by the game’s finishes.',
  },
  {
    what: 'Stiletto knife',
    title: 'Stiletto Knife',
    author: '3dane',
    authorUrl: 'https://sketchfab.com/3dane',
    source: 'https://sketchfab.com/3d-models/stiletto-knife-5b3927b0d8f043ef8612f5eac4bfae74',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes:
      'Split into blade, fittings and scales and simplified; its textures replaced by plain colours and the game’s finishes.',
  },
  {
    what: 'Skeleton knife',
    title: 'sapphire doppler skeleton knife (CS2 reference)',
    author: 'Mvlyy',
    authorUrl: 'https://sketchfab.com/Mvlyy',
    source:
      'https://sketchfab.com/3d-models/sapphire-doppler-skeleton-knife-cs2-reference-91dd224cb3ee42ac8025227dac5320f1',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into handle and blade; its textures replaced by the game’s finishes.',
  },
  {
    what: 'Kukri knife',
    title: 'Knife - Kukri | GameReady, PBR',
    author: 'snji',
    authorUrl: 'https://sketchfab.com/snji',
    source: 'https://sketchfab.com/3d-models/knife-kukri-gameready-pbr-557913a0811141fa96e6d2dd6dc1c42c',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into blade, guard and grip; its textures replaced by the game’s finishes.',
  },
  {
    what: 'Talon knife',
    title: 'Counter strike talon knife',
    author: 'Mat_Dhyne',
    authorUrl: 'https://sketchfab.com/Mat_Dhyne',
    source: 'https://sketchfab.com/3d-models/counter-strike-talon-knife-870de99fe0434115b8b4c62ebfee3fc3',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Cut into parts and simplified; recoloured with the game’s finishes.',
  },
  {
    what: 'Bowie knife',
    title: 'Ontario SP 10 Bowie knife',
    author: 'HorusZ',
    authorUrl: 'https://sketchfab.com/HorusZ',
    source: 'https://sketchfab.com/3d-models/ontario-sp-10-bowie-knife-8c1ff8729176416ab8dbd0fd64644dc0',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into blade, guard and grip; its textures replaced by the game’s finishes.',
  },
  {
    what: 'Pistol',
    title: 'USP-S',
    author: 'DFS studio',
    authorUrl: 'https://sketchfab.com/DFS_studio',
    source: 'https://sketchfab.com/3d-models/csgo-usp-s-215cb172fb2d4027af6ed64ba8c29c6f',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Recoloured with the game’s finishes; fitted to the arm rig.',
  },
  {
    what: 'Pistol animations',
    title: 'Fps Rig',
    author: 'J-Toastie',
    source: 'https://poly.pizza/m/uxko5LkGia',
    license: 'CC BY 3.0',
    licenseUrl: 'https://creativecommons.org/licenses/by/3.0/',
    changes: 'Silencer added; its arms and gun replaced by the models above.',
  },
  {
    what: 'Textures, scenery models and sounds',
    title: 'Kenney game assets',
    author: 'Kenney',
    authorUrl: 'https://kenney.nl',
    source: 'https://kenney.nl/assets',
    license: 'CC0 (public domain)',
    licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
    changes:
      'Nature, Space, Holiday, Graveyard, Platformer, City Commercial, City Suburban, Retro Urban, Survival, ' +
      'Factory, Tower Defense, Castle, Pirate and Mini Arena kits, prototype textures, patterns and sounds.',
  },
  {
    what: 'Ruins scenery',
    title: 'Ancient Ruins',
    author: 'Maksim Batyrev (c3posw01)',
    authorUrl: 'https://sketchfab.com/c3posw01',
    source: 'https://sketchfab.com/3d-models/ancient-ruins-105c85f4668245208fe71cac4861cf8c',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into separate models, textures resized; used as scenery in the maps and builder.',
  },
  {
    what: 'Forest scenery',
    title: 'low poly forest pack, low poly environment pack',
    author: 'Ragat Vdoo Kaf (mae_bul_01)',
    authorUrl: 'https://sketchfab.com/mae_bul_01',
    source:
      'https://sketchfab.com/3d-models/low-poly-forest-pack-low-poly-environment-pack-47b2cb567d1b437fb86d2897353079ab',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into separate models, textures resized; used as scenery in the maps and builder.',
  },
  {
    what: 'Reed scenery',
    title: 'Reed Plants Pack',
    author: 'Nicholas-3D (Nicholas01)',
    authorUrl: 'https://sketchfab.com/Nicholas01',
    source: 'https://sketchfab.com/3d-models/reed-plants-pack-bc77ea5218e44f2dbc23b2a4aef0c898',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into separate models, textures resized; used as scenery in the maps and builder.',
  },
  {
    what: 'Ivy scenery',
    title: 'low poly Ivy',
    author: 'spicybamer',
    authorUrl: 'https://sketchfab.com/smitecraft.swe',
    source: 'https://sketchfab.com/3d-models/low-poly-ivy-695e4b177a884b318e21c084f66c3a6c',
    license: 'CC BY 4.0',
    licenseUrl: CC_BY_4,
    changes: 'Split into separate models, textures resized; used as scenery in the maps and builder.',
  },
  {
    what: 'Surface textures',
    title: 'ambientCG materials',
    author: 'ambientCG (Lennart Demes)',
    authorUrl: 'https://ambientcg.com',
    source: 'https://ambientcg.com',
    license: 'CC0 (public domain)',
    licenseUrl: 'https://creativecommons.org/publicdomain/zero/1.0/',
    changes:
      'Grass004, Moss002, Ground037, Ground054, Gravel023, Rock030, Rock035, Bark012, WoodFloor041, ' +
      'PavingStones092, Tiles074, Marble012, Concrete034, MetalPlates006, PaintedMetal017, Snow006, Ice002 and ' +
      'Lava004, resized to 1024 px.',
  },
];

const LIBRARIES: [string, string, string][] = [
  ['three.js', 'https://threejs.org', 'MIT'],
  ['7z-wasm (7-Zip by Igor Pavlov)', 'https://github.com/use-strict/7z-wasm', 'GNU LGPL + unRAR restriction'],
  ['node-unrar-js', 'https://github.com/YuJianrong/node-unrar.js', 'MIT'],
  ['fflate', 'https://github.com/101arrowz/fflate', 'MIT'],
  ['meshoptimizer (to prepare the models)', 'https://github.com/zeux/meshoptimizer', 'MIT'],
];

function link(text: string, href: string | undefined) {
  if (!href) return document.createTextNode(text);
  const a = document.createElement('a');
  a.href = href;
  a.target = '_blank';
  a.rel = 'noopener';
  a.textContent = text;
  return a;
}

function el<K extends keyof HTMLElementTagNameMap>(tag: K, className: string, ...kids: (Node | string)[]) {
  const e = document.createElement(tag);
  e.className = className;
  e.append(...kids);
  return e;
}

export class CreditsPanel {
  private readonly root = document.getElementById('credits')!;
  private lastFocus: HTMLElement | null = null;

  constructor() {
    this.render();
    document.getElementById('creditsOpen')!.addEventListener('click', () => this.open());
    document.getElementById('creditsClose')!.addEventListener('click', () => this.close());
    this.root.addEventListener('click', (e) => {
      if (e.target === this.root) this.close();
    });
    window.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.isOpen) {
        e.stopPropagation();
        this.close();
      }
    });
  }

  get isOpen() {
    return !this.root.hidden;
  }

  open() {
    this.lastFocus = document.activeElement as HTMLElement | null;
    this.root.hidden = false;
    document.getElementById('creditsClose')!.focus();
  }

  close() {
    this.root.hidden = true;
    this.lastFocus?.focus();
  }

  private render() {
    const body = document.getElementById('creditsBody')!;
    body.textContent = '';
    body.append(el('h3', '', 'Creator'));
    body.append(el('p', 'creditNote creditCreator', 'CSS-BHOP is made by ', el('b', '', 'LasBoi'), '.'));
    body.append(el('h3', '', 'Models, textures and sounds'));
    const list = el('ul', 'creditList');
    for (const c of ASSETS) {
      const head = el('div', 'creditHead', el('b', '', c.what), ': ');
      head.append(link(`“${c.title}”`, c.source), ' by ', link(c.author, c.authorUrl));
      const meta = el('div', 'creditMeta', 'Licence: ');
      meta.append(link(c.license, c.licenseUrl));
      if (c.changes) meta.append(' · ', c.changes);
      list.append(el('li', '', head, meta));
    }
    body.append(list);

    body.append(el('h3', '', 'Music'));
    body.append(
      el(
        'p',
        'creditNote',
        'Bhop By LasBoi: the game’s own songs, made by LasBoi for CSS-BHOP. They play on their own station and in the mix.',
      ),
    );
    const mus = el(
      'p',
      'creditNote',
      'The other stations stream from ',
      link('Audius', 'https://audius.co'),
      ": the month's trending Dubstep, Drum & Bass and Electronic tracks, played straight from Audius " +
        "(nothing is copied or hosted here). Each track's title and artist are shown while it plays, " +
        'with a link to it on Audius. Settings, Video and sound shows what is playing.',
    );
    body.append(mus);

    body.append(el('h3', '', 'Community maps'));
    body.append(
      el(
        'p',
        'creditNote',
        'Maps in the CS:S maps tab are made by their authors and come from GameBanana. Each map shows its ' +
          'credits there; its Download button gets the file straight from GameBanana. The game never hosts ' +
          'or re-uploads them.',
      ),
    );
    body.append(
      el(
        'p',
        'creditNote',
        'Standard timer zones for loaded maps come from ',
        link('zones-cstrike', 'https://github.com/ddyfad/zones-cstrike'),
        ' (the zones bhop servers use with shavit’s bhoptimer, from the cutehops and SourceJump zone dumps).',
      ),
    );

    body.append(el('h3', '', 'Software'));
    const libs = el('ul', 'creditList compact');
    for (const [name, url, license] of LIBRARIES) libs.append(el('li', '', link(name, url), ` (${license})`));
    body.append(libs);

    body.append(
      el(
        'p',
        'creditNote',
        'No Valve assets are included. If you link your own Counter-Strike: Source folder, its textures, ' +
          'weapon models and sounds are read from your copy and stay on your computer.',
      ),
    );
  }
}
